import { ref, reactive } from 'vue';
import "ant-design-vue/es/message/style/css";
import _message from "ant-design-vue/es/message";
import { Post, Get } from '@/api/Api';
import { GetBaseUrl } from '@/utils/request';
export default {
  name: 'Index',
  components: {},
  setup(props, context) {
    const RefForm = ref();
    const DMConfig = reactive({
      FId: 0,
      loading: false,
      Model: {},
      DMForm: {
        form: {
          labelCol: {
            style: {
              width: '140px'
            }
          }
        }
      }
    });
    const SubmitForm = e => {
      RefForm.value.validate().then(() => {
        console.log('values11', DMConfig.Model);
        DMConfig.loading = true;
        Post("DM/SaveConfig", DMConfig.Model).then(res => {
          if (res.succeeded) {
            _message.success('保存成功');
          } else {
            _message.error('保存失败：' + res.errors);
            DMConfig.loading = false;
          }
        }).catch(err => {
          _message.error(err.errors);
          DMConfig.loading = false;
        });
      }).catch(error => {
        console.log(error);
        //message.error(error.message);
      });
    };

    const ResetForm = (form, DataSource) => {
      console.log('DataSource');
    };
    Get("/DM/ConfigListAll").then(res => {
      DMConfig.Model = res.data;
      DMConfig.loading = false;
    });
    return {
      RefForm,
      DMConfig,
      SubmitForm,
      ResetForm
    };
  },
  created() {},
  mounted() {},
  methods: {}
};